import { Alert, Modal, Space } from 'antd'
import { observer } from 'mobx-react-lite'

import { Form, FormField } from '@/Core/UI/Form'

import { CRM_VERIFICATION_TEXTS as T } from './CrmVerification'

import type { VerificationStore } from './VerificationStore'

/**
 * Модалка «Верифікація клієнта» / «Верифікація перевізника» (`SPEC-008` §7.2,
 * `SPEC-009` §8.6): експедитор (передзаповнений з картки), номер і дата
 * договору — усі обов'язкові. Після підтвердження бек створює договір у тій
 * самій транзакції (КЛ-18), тож підказка власника (`verifyHint`) пояснює, де
 * його шукати.
 *
 * Поля — ядрова форма: обов'язковість перевіряє вона ж, а 422 полів тіла
 * `VerificationStore` кладе під ті самі поля.
 */
export const VerifyModal = observer(({ store }: { store: VerificationStore }) => {
    const form = store.verifyForm

    return (
        <Modal
            title={store.config.texts.verifyModalTitle}
            open={store.verifyOpen && form !== null}
            okText={T.save}
            cancelText={T.close}
            okButtonProps={{ loading: store.pending === 'verify' }}
            onOk={() => store.submitVerifyForm()}
            onCancel={() => store.closeVerify()}
            destroyOnHidden
            maskClosable={false}
        >
            {form ? (
                <Space orientation="vertical" style={{ width: '100%' }} size="middle">
                    {store.verifyError ? <Alert type="error" showIcon title={store.verifyError} /> : null}
                    {store.config.verifyHint ?? null}
                    <Form formContext={form}>
                        <FormField name="contractForwarder" />
                        <FormField name="contractNumber" />
                        <FormField name="contractDate" />
                    </Form>
                </Space>
            ) : null}
        </Modal>
    )
})
